export const munvoBlue = '#26568d'
export const munvoOrange = '#FD9505'
export const munvoGray = '#666766'